<div class="flex flex-row" [class.relative]="!!badge">
  @for (avatar of avatars | slice: 0 : 4; track avatar.name; let i = $index) {
    <img
      [matTooltip]="avatar?.name"
      [src]="avatar?.imageSrc"
      class="cursor-pointer m-2px text-card shadow-solid bg-black-200"
      [class.rounded-full]="!roundedCorners()"
      [ngClass]="{ '-ml-1': i > 0, 'w-6 h-6': size === 'normal', 'w-12 h-12': size === 'big' }"
      alt="{{ avatar?.name }}"
    />
    @if (badge) {
      <ts-badge [value]="badge" type="avatar" class="absolute bottom-0 floating-badge"></ts-badge>
    }
  }
  @if (hasMaxNumberOfAvatars) {
    <div
      class="w-6 -ml-1 h-6 m-2px rounded-full text-card shadow-solid bg-black-200 flex flex-row items-center justify-center"
    >
      <p class="text-sm text-black-500">+{{ avatarsCountAfterTheFourth }}</p>
    </div>
  }
</div>
